module.exports = __webpack_public_path__ + "static/favicon-f2b40aefb2a94223c57da43ee295f13d.ico";